'use client';
import { Box } from '@mui/material';
import { mergeSx } from 'merge-sx';
import { FC, useState } from 'react';

import { AbgTypography, ArrowForwardIcon } from '@abg/kit-base';

import { AemImage } from '../AemImage';
import { AvisFirstLongLogo } from '../AvisFirstLogo';

import {
  arrowIconStyles,
  bannerContainerStyles,
  contentStyles,
  descriptionStyles,
  logoStyles,
  redAccentLineStyles,
} from './avis-first-alert-banner.styling';
import { AvisFirstAlertBannerProps } from './avis-first-alert-banner.types';

export const AvisFirstAlertBanner: FC<AvisFirstAlertBannerProps> = ({
  description,
  onClick,
  sx,
  logoUrl,
}) => {
  const [logoFailed, setLogoFailed] = useState(false);
  const showAemLogo = Boolean(logoUrl) && !logoFailed;

  return (
    <Box
      sx={mergeSx(bannerContainerStyles, sx)}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onClick?.();
        }
      }}
      data-testid="avis-first-alert-banner"
      aria-label={description}
    >
      <Box sx={redAccentLineStyles} aria-hidden="true" />
      <Box sx={contentStyles}>
        <Box sx={logoStyles as Record<string, unknown>}>
          {showAemLogo ? (
            <AemImage
              src={logoUrl as string}
              alt="Avis First"
              fill
              style={{ objectFit: 'contain' }}
              onError={() => setLogoFailed(true)}
              data-testid="avis-first-alert-banner-logo"
            />
          ) : (
            <AvisFirstLongLogo
              firstPartColor="#d4012a"
              secondPartColor="#FFFFFF"
              width="100%"
              height="100%"
              viewBox="0 0 144 20"
              aria-label="Avis First"
            />
          )}
        </Box>
        <AbgTypography sx={descriptionStyles}>{description}</AbgTypography>
      </Box>
      <ArrowForwardIcon sx={arrowIconStyles} aria-hidden="true" />
    </Box>
  );
};
